import { Text } from '@shared/components/Text';
import { useTimer } from './hooks';
import { formatMillisecondsToDurationString } from './utils';
import classNames from './text.module.css';

//#region Public Interface

interface Props {
  isRunning: boolean;
  interval?: number;
  onTick: (now: Date) => number;
}

export function TimerText({ isRunning, interval = 1000, onTick }: Props) {
  const now = useTimer(interval, isRunning);
  const duration = onTick(now);
  const durationString = formatMillisecondsToDurationString(duration, true);
  return <Text className={classNames.timerText}>{durationString}</Text>;
}

//#endregion
